import {createContext, useContext, useEffect} from "react";
import {useFetchState} from "../useFetchState";
import {UserController} from "services/user/UserController";
import {isAuthenticated} from "../../isAuthenticated";

export const UserInfoContext = createContext(null);

const UserInfoProvider = ({children}) => {
    const user = UserController();
    const [fetchState, sendRequest] = useFetchState();

    const updateInfo = () => {
        if(isAuthenticated()){
            sendRequest(user.getCurrentUserInfo, null);
        }
    };

    useEffect(() => {
        updateInfo();
    }, []); //eslint-disable-line

    return (
        <UserInfoContext.Provider value={{info: fetchState.data, updateInfo}}>
            {children}
        </UserInfoContext.Provider>
    );
}

export const useInfo = () => useContext(UserInfoContext);

export default UserInfoProvider;